import React from 'react';
import { GreyButtonText, GreyButtonContainer } from './GreyButtonStyle';
import { redirectUser } from '../../../../utils';

interface IButtonProps {
  content: string;
  redirect: string;
}

export const GreyButton = ({ content, redirect }: IButtonProps) => {
  return (
    <GreyButtonContainer
      beforeContent={content}
      onClick={() => redirectUser(redirect)}>
          <GreyButtonText>{content}</GreyButtonText>
    </GreyButtonContainer>
  );
};

